<template>
  <div
    style="border: 0px solid black; width:100%;"
    v-if="has_perm('view_email_template') || GET_ACCOUNT_DATA.group_id == 1"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <label for="name">{{ $t("mail_form_list.title") }}</label>
              <div>
                <lte-button
                  style="float:right;background-color:white !important; margin-right: 50px"
                  type="btn btn-default"
                  right_icon="fa fa-plus"
                  v-if="has_perm('create_email_template') || GET_ACCOUNT_DATA.group_id == 1"
                  @click="onhandleAddNew"
                >
                  {{ $t("mail_form_list.add_new") }}
                </lte-button>
              </div>
            </div>
          </div>
          <div class="box-body">
            <div>
              <b-table
                :per-page="perPage"
                :current-page="currentPage"
                striped
                hover
                :fields="fields"
                :items="templateEmaillist"
              >
                <template #cell(content)="row">
                  <div v-html="row.item.content"></div>
                </template>
                <template #cell(actions)="row">
                  <div class="btn-group">
                    <button
                      v-if="
                        has_perm('update_email_template') ||
                          GET_ACCOUNT_DATA.group_id == 1
                      "
                      @click="onhandleEdit(row)"
                      class="btn btn-primary"
                      style="margin-left: 6px"
                    >
                      <i class="glyphicon glyphicon-edit"></i>
                    </button>
                    <button
                      v-if="
                        has_perm('delete_email_template') ||
                          GET_ACCOUNT_DATA.group_id == 1
                      "
                      @click="onhandleDelete(row)"
                      class="btn btn-danger"
                      style="margin-left: 6px"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <!-- b pagina -->
              <div v-if="templateEmaillist.length > 0" class="box-footer clearfix" style="display:contents;">
                <paginator
                  :totalItem="paginateData.totalItem"
                  :currentPage="paginateData.currentPage"
                  :pageSize="paginateData.pageSize"
                  :totalPage="paginateData.totalPage"
                  @onpaginate="onPagination"
                />
              </div>
              <!-- end pagi -->
            </div>
            <!-- Modal Confirm Delete -->
            <div class="modal fade" :ref="`modal-pkg-tp`">
              <div class="modal-dialog">
                <confirm :id="pkg_tp_data.id" @confirm="onDeleteConfirm" />
              </div>
            </div>

            <!-- snackbar -->
            <lte-core-alert
              v-for="snackbar in GET_SNACK_BAR"
              :key="snackbar.id"
              :item="snackbar"
            ></lte-core-alert>
            <!-- /.modal-dialog -->
          </div>
        </div>
      </row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Confirm from "@/components/Confirm.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import LTEButton from "@/components/LTEButton.vue";
import utils from '@/lib/utils';
import Paginator from "@/components/CustomPaginator.vue";

export default {
  name: "ManagementEmailFormList",
  data() {
    return {
      templateEmaillist: [],
      pkg_tp_data: {
        id: 0
      },
      currentPage: 1,
      totalRows: 1,
      perPage: 50,
      fields: [
        {
          key: "STT",
          label: "STT",
          sortable: true,
          class: "text-center",
          tdClass: "stt"
        },
        {
          key: "name",
          label: this.$t("mail_form.form_name"),
          sortable: true,
          class: "text-center"
        },
        {
          key: "subject",
          label: this.$t("mail_form.subject"),
          sortable: true,
          class: "text-center"
        },
        // {
        //   key: "content",
        //   label: this.$t("mail_form.content"),
        //   sortable: true,
        //   class: "align-left"
        // },
        // {
        //   key: "active",
        //   label: this.$t("mail_form.active"),
        //   sortable: true,
        //   class: "text-center"
        // },
        {
          key: "classify",
          label: this.$t("mail_form.classify"),
          sortable: true,
          class: "text-center"
        },
        {
          key: "actions",
          label: this.$t("mail_form.action"),
          class: "actions_style"
        }
      ],
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      }
    };
  },
  watch: {
    GET_TEMPLATE_EMAIL_DATA: function() {
      let paginate = this.GET_TEMPLATE_EMAIL_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.templateEmaillist = [];
      this.GET_TEMPLATE_EMAIL_DATA.results.forEach((tp, idx) => {
        let data = {
          STT: idx + 1 + (paginate.currentPage - 1) * paginate.pageSize,
          name: this.add3Dots(tp.name,50),
          id: tp.id,
          subject: this.add3Dots(tp.subject, 70),
          content: tp.content,
          active: tp.active,
          classify: tp.classify,
          email_object: tp.email_object
        };
        this.templateEmaillist.push(data);
      });
      this.totalRows = this.templateEmaillist.length;
    }
  },
  computed: {
    ...mapGetters([
      "GET_TEMPLATE_EMAIL_DATA",
      "GET_ACCOUNT_DATA",
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW"
    ])
  },
  methods: {
    ...mapActions([
      "GET_TEMPLATE_DATA",
      "DELETE_FORM_EMAIL",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "ON_SHOW_TOAST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onhandleAddNew() {
      this.$router.push({
        name: "EmailFormAdd",
        params: {
          id: 0
        }
      });
    },
    add3Dots: function(string, limit)
    {
      var dots = "...";
      if (this.$route.params.id != 0)
      {
        if(string.length > limit)
        {
          // you can also use substr instead of substring
          string = string.substring(0,limit) + dots;
        }
          return string;
      }
      else{
        return string
      }
    },
    onhandleDelete: function(row) {
      this.pkg_tp_data.id = row.item.id;
      this.onToggleDeleteConfirm();
    },
    onToggleDeleteConfirm: function(action = "show") {
      $(this.$refs[`modal-pkg-tp`]).modal(action);
    },
    onDeleteConfirm: function(id) {
      const payload = {
        id: id
      };
      this.DELETE_FORM_EMAIL(payload)
        .then(
          function() {
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.templateEmaillist == 1
                ? totalPage >= 2
                  ? totalPage - 1
                  : 1
                : currentPage;
            this.getTemplateList(page);
            $(this.$refs[`modal-pkg-tp`]).modal("hide");
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            if (error.response.data.message=='un_delete_template')
            {
              this.ON_SHOW_TOAST({
                message: this.$t("mail_form.undelete_template"),
                styleType: 'danger'
              })
            }
            else{
              this.ERROR_TOAST()
            }
            $(this.$refs[`modal-pkg-tp`]).modal("hide");
        }.bind(this)
        );
    },

    onhandleEdit: function(row) {
      let id = row.item.id;
      this.$router.push({
        name: "EmailFormAdd",
        params: {
          id: id
        }
      });
    },
    onPagination: function(data) {
      this.paginateData.currentPage = data
      this.getTemplateList(data)
    },
    getTemplateList: function(page) {
      let filter = {
        params: {
          page: page
        }
      }
      this.GET_TEMPLATE_DATA(filter)
    }
  },
  mounted() {
    this.getTemplateList(1);
  },
  components: {
    confirm: Confirm,
    "lte-core-alert": LTECoreAlert,
    "lte-button": LTEButton,
    paginator: Paginator,
  }
};
</script>

<style>
.stt {
  width: 1rem;
}
.actions_style{
  display: flex;
  justify-content: flex-end;
}

</style>



// WEBPACK FOOTER //
// src/views/Mailbox/ManagementEmailFormList.vue